:host {
    --wcs-divider-color: var(--wcs-semantic-color-border-secondary);
    --wcs-divider-height: var(--wcs-semantic-border-width-default);

    display: block;
    border-bottom: solid var(--wcs-divider-height) var(--wcs-divider-color);
}
